import isFunction from "lodash/isFunction"

export default function captureNextEvent(type, target, callback) {
  const el = !isFunction(target) && target ? target : window
  const cb = isFunction(target) ? target : callback

  const capture = e => {
    e.stopPropagation()

    if (cb) {
      cb(e)
    }

    el.removeEventListener(type, capture, true)
  }

  el.addEventListener(type, capture, true)
}
